import React, { Component } from 'react';
import StandardCtaBox from '../StandardCtaBox/StandardCtaBox.js';

class BannerStaticContent extends Component {

    render() {
        return (
            <div id="staticContentBanner" className="banner-static__content__block mw-100 w-100">
                {this.props.useOverlay ? <div className="banner-static__content_overlay"></div> : ''}
                <StandardCtaBox
                    ctaTitle={this.props.ctaTitle}
                    ctaContentText={this.props.contentText}
                    ctaButtonLabel={this.props.ctaButtonLabel}
                    ctaButtonHref={this.props.ctaButtonHref}
                    ariaLabel={this.props.ariaLabel}
                ></StandardCtaBox>
            </div>
        );
    }
}

export default BannerStaticContent;